import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import DateTab from './date-tab';
import { DATE_FORMATS } from '../../utils';
import DateSelector from './date-selector';

const CalendarHeader = ({
  onPreviousWeekClicked,
  onPreviousDayClicked,
  onNextWeekClicked,
  onNextDayClicked,
  isPreviousWeekBtnDisabled,
  isPreviousDayBtnDisabled,
  dateRange,
  selectedDate,
  onDateSelected,
}) => {
  const renderDayOfWeek = (day, index) => {
    return (
      <DateTab
        key={index}
        day={day}
        selectedDate={selectedDate}
        onClick={onDateSelected}
      />
    );
  };

  const dates = Array.from(dateRange.by('day')).map(renderDayOfWeek);

  return (
    <div className="fs-activity-calendar-header">
      <div className="controls">
        <button
          className="previous-btn control-btn is-mobile"
          disabled={isPreviousDayBtnDisabled}
          onClick={onPreviousDayClicked}
        >
          <i className="caret caret-left" />
        </button>
        <button
          className="previous-btn control-btn is-desktop"
          disabled={isPreviousWeekBtnDisabled}
          onClick={onPreviousWeekClicked}
        >
          Previous week
        </button>

        <div className="date-heading">
          <DatePicker
            customInput={<DateSelector />}
            minDate={moment()}
            calendarClassName="date-picker"
            popperPlacement="top-start"
            selected={selectedDate}
            dateFormat={DATE_FORMATS.FULL}
            onChange={onDateSelected}
          />
        </div>

        <button
          className="next-btn control-btn is-mobile"
          onClick={onNextDayClicked}
        >
          <i className="caret caret-right" />
        </button>
        <button
          className="next-btn control-btn is-desktop"
          onClick={onNextWeekClicked}
        >
          Next week
        </button>
      </div>
      <div className="date-tabs">
        {dates}
      </div>
    </div>
  );
};

CalendarHeader.propTypes = {
  dateRange: PropTypes.object.isRequired,
  selectedDate: PropTypes.object.isRequired,
  isPreviousWeekBtnDisabled: PropTypes.bool.isRequired,
  isPreviousDayBtnDisabled: PropTypes.bool.isRequired,
  onPreviousWeekClicked: PropTypes.func.isRequired,
  onPreviousDayClicked: PropTypes.func.isRequired,
  onNextWeekClicked: PropTypes.func.isRequired,
  onNextDayClicked: PropTypes.func.isRequired,
  onDateSelected: PropTypes.func.isRequired,
};

export default CalendarHeader;



// WEBPACK FOOTER //
// ./components/calendar-header/index.js